module.exports = {"pagination":{"ListRetainedMessages":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"retainedTopics"}}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/aws-sdk/apis/iot-data-2015-05-28.paginators.json
// module id = 1695
// module chunks = 3